import { forwardRef } from 'react'

import { useDisconnectButton } from '@/src/hooks'
import { useAppSelector } from '@/src/store/hooks'
import { selectBranding } from '@/src/store/slices/meetData'

/** @public */
export interface CallEndButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  stopTracks?: boolean
}

/**
 * The `CallEndButton` is a button that allows the user to end an ongoing call.
 * Typically styled as a prominent red button to indicate the action of hanging up.
 *
 * @example
 * ```tsx
 * <LiveKitRoom>
 *   <CallEndButton>End Call</CallEndButton>
 * </LiveKitRoom>
 * ```
 * @public
 */
export const CallEndButton = /* @__PURE__ */ forwardRef<
  HTMLButtonElement,
  CallEndButtonProps
>(function CallEndButton(props: CallEndButtonProps, ref) {
  const { border_radius: borderRadius } = useAppSelector(selectBranding)
  const { buttonProps } = useDisconnectButton(props)

  return (
    <button
      ref={ref}
      disabled={buttonProps.disabled}
      className={buttonProps.className}
      style={{ borderRadius }}
      {...props}
    >
      {props.children}
    </button>
  )
})